import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress/nprogress'
import routes from './routes'

NProgress.configure({ showSpinner: false })

const router = createRouter({
  history: createWebHistory('/dashboard2/'),
  routes,
  scrollBehavior: (to, from, savedPosition) => savedPosition || { left: 0, top: 0 }
})

// Set page meta
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const descEl = document.querySelector('meta[name=description]')
  if (descEl && to.meta.description) {
    descEl.content = to.meta.description
  }
  next()
})

// Trigger the Progress Bar
router.beforeResolve((routeTo, routeFrom, next) => {
  if (routeFrom.name) NProgress.start()
  next()
})
router.afterEach(() => NProgress.done())

export default router
